<template>
  <b-overlay
      :show="show"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <b-card title="Master Project">
      <!-- <b-card-text>Project.</b-card-text> -->
      <validation-observer ref="simpleRules">
        <b-form @submit.prevent>
          <b-row>
            <!-- Company -->
            <b-col cols="12">
              <b-form-group label="Company" label-for="v-Company">
                <validation-provider #default="{ errors }"  name="Company">
                  <v-select id="v-Company" v-model="form.select_1" placeholder="Chose Company" autocomplete="off" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" label="title" :options="companyOptions" :reduce="companyOptions => companyOptions.value"/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Name -->
            <b-col cols="12">
              <b-form-group label="Name" label-for="v-Name">
                <validation-provider #default="{ errors }"  name="Name" rules="required">
                  <b-form-input  id="v-Name" :state="errors.length > 0 ? false:null" v-model="form.text_1" placeholder="Name" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Description -->
            <b-col cols="12">
              <b-form-group label="Description" label-for="v-Description">
                <validation-provider #default="{ errors }"  name="Description" rules="required">
                  <b-form-input  id="v-Description" :state="errors.length > 0 ? false:null" v-model="form.text_2" placeholder="Description" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- submit and reset -->
            <b-col cols="12"><div class="h-50 d-inline-block"></div></b-col>
            <b-col cols="12">
              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="primary" class="mr-1" @click.prevent="validationForm"> Submit </b-button>
              <b-button v-ripple.400="'rgba(186, 191, 199, 0.15)'" type="reset" variant="outline-secondary"> Reset </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
      </b-card>
  </b-overlay>
</template>
<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { BRow, BOverlay, BCardText, BFormFile, BMediaBody, BMedia, BMediaAside, BLink, BCol, BFormGroup, BFormCheckbox,  BFormInput, BForm, BButton, BCard,  BImg} from 'bootstrap-vue'
import { mapState } from 'vuex'
import { required } from '@validations'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
export default {
  components: { vSelect, BOverlay, BCardText, BFormFile, BMediaBody, BMedia, BMediaAside, BLink, BFormCheckbox,  ValidationProvider, ValidationObserver, BCard, BImg, BRow, BCol, BFormGroup, BFormInput, BForm, BButton },
  directives: { Ripple },
  data () {
    return { 
      form: {id: null, select_4: '', text_1: '',text_2: '', text_3: '', imageUrl: require('@/assets/images/icons/jpg.png'), setImage: 'none', logo: null},
      show: false,
      required 
    }
  },
  computed: {
    ...mapState({ companyOptions: state => state.company.options})
  },
  created () {
    this.$store.dispatch('company/getAll')
  },
  watch: {
    select_1 (obj) {
      return this.$store.dispatch('company/getAll', obj)
		},
  },
  methods: {
    validationForm () {
      this.show = true
      this.$refs.simpleRules.validate()
      .then(success => {
        if (success) {
          const formData = this.form 
			    this.$store.dispatch('project/formPostPut', formData)
          .then(res => {
            this.notification('Success','CheckIcon','success','You have successfully')
          }, 
          err => {
            this.show = false
            this.notification('Failed','CloseIcon','danger','You have unsuccessful')
          })
        } else {
          this.show = false
          this.notification('Failed','CloseIcon','danger','You have unsuccessful')
        }
      })
    },
    notification (a,b,c,d) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: { title: a, icon: b, variant: c, text: d}
      })
    },
    getData (id) {
			this.$store.dispatch('project/getById', id).then(data => {
        this.form.id = data.id
        this.form.text_1 = data.name
        this.form.text_2 = data.description
        this.form.select_1 = data.company_id
        this.show = false
      })
    }
  },
  mounted () {
    this.$store.dispatch('company/getAll')
    if (this.$route.params.id) {
      this.show = true
      this.getData(this.$route.params.id)
    }
  }
}
</script>
<style lang="scss" >
@import '@core/scss/vue/libs/vue-select.scss';
</style>